import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, MapPin } from "@phosphor-icons/react";
import { useProjects } from "../../lib/api";

export const FeaturedProjects = () => {
  const { data: projects = [] } = useProjects();
  const featured = projects.filter((p) => p.featured).slice(0, 3);

  return (
    <section data-testid="featured-projects-section" className="bg-panel border-y border-line py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="overline-label mb-4">02 — Proof of Work</p>
            <h2 className="font-heading font-medium text-3xl md:text-4xl tracking-tight text-ink max-w-xl">
              Recent projects, delivered on mission.
            </h2>
          </div>
          <Link
            to="/projects"
            data-testid="projects-view-all"
            className="inline-flex items-center gap-2 text-sm font-medium text-blueprint hover:gap-3 transition-all"
          >
            All projects <ArrowUpRight size={16} />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featured.map((p, i) => (
            <motion.article
              key={p.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.12 }}
              data-testid={`featured-project-${i}`}
              className="group bg-canvas border border-line transition-all hover:-translate-y-1 hover:shadow-lg"
            >
              <div className="relative h-56 overflow-hidden">
                <img src={p.image} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <span className="absolute top-4 left-4 font-mono-tech text-[10px] tracking-[0.18em] uppercase bg-black/70 text-white px-2.5 py-1">
                  {p.category}
                </span>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 text-xs text-sub font-mono-tech mb-2">
                  <MapPin size={13} className="text-blueprint" /> {p.location} · {p.year}
                </div>
                <h3 className="font-heading font-medium text-xl tracking-tight text-ink">{p.title}</h3>
                <p className="mt-2 text-sm text-sub leading-relaxed line-clamp-3">{p.description}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
